import '../../less/animal-rx.less';
import Price from "JS/components/price/Price.vue";
import Vue from 'vue';
import { createListSlider } from "../list-slider";
import { onWindowResize } from "../utilities/viewport";


const trendingCarousels = document.querySelectorAll(".trending-carousel");
for (let i = 0; i < trendingCarousels.length; i++) {
	const trendingViewport = trendingCarousels[i].querySelector('[data-list-slider-viewport]');
	if (trendingViewport) {

		const trendListSlider = createListSlider(trendingViewport);
		trendListSlider.setControls(trendingCarousels[i].querySelector(".trending-carousel__left-button"), trendingCarousels[i].querySelector(".trending-carousel__right-button"));
		onWindowResize(() => trendListSlider.reset());
	}
}

const priceRoots = document.querySelectorAll("[data-product]");
for (const el of priceRoots) {
	const productIn = JSON.parse(el.dataset.product);
	new Vue({
		el,
		render: h => h(Price, {
			props: {
				product: productIn
			}
		})
	});
}